module.exports = __webpack_public_path__ + "img/GBM1_TMKI67.7720db2c.png";